import React, { useEffect, useRef, useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { formatJsonToReadableText, prettyFormatObject } from "../../../utils";

export default function TextArea({
    data,
    label,
    placeholder,
    onBlur = () => { },
    trim,
    message,
    attr,
    ...params
}) {
    const [value, setValue] = useState(data?.[attr]);
    const timeoutRef = useRef(null);

    function onChange(e) {
        const val = trim ? e.target.value.trim() : e.target.value;
        setValue(val);

        // Очистить предыдущий таймер
        clearTimeout(timeoutRef.current);

        // Установить новый таймер
        timeoutRef.current = setTimeout(() => {
            onBlur(e, attr, val);
        }, 500); // или 1000 для 1 секунды
    }

    useEffect(() => {
        setValue(formatJsonToReadableText(data?.[attr]));
        console.log(data?.[attr]);
    }, [data?.[attr]]);

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current); // очистка при размонтировании
    }, []);

    return (
        <div className="flex justify-content-center">
            <div className="editor">
                {label && <label className="editor_label" htmlFor={label}>{label}</label>}
                <InputTextarea className="p-inputtext-sm" value={value} onChange={onChange} {...params} />

                {message && <small id="username-help">{message}</small>}
            </div>
        </div>
    )
}